<div class="flex flex-row justify-between items-start gap-8 mt-1 mb-1">
  <rfc-title-widget [titleWidget]="defineTitleAndDescriptionWidgetObj('manage_customer_service')"
    class="flex-1"></rfc-title-widget>

  <mat-icon class="cursor-pointer hover:opacity-70 transition-opacity" *ngIf="!!dialogRef.id && closable"
    (click)="onClose()">close</mat-icon>
</div>

<div *ngIf="!!!cSModelRetrieved">
  <div [formGroup]="csForm" class="flex flex-col md:flex-row justify-around items-center gap-4 mt-1 mb-1">
    <mat-form-field class="w-full md:w-1/2">
      <mat-label>{{ "choose_customer2_manage" | i18n | titlecase }} </mat-label>
      <input matInput type="number" formControlName="customerRefId" [(ngModel)]="inputValue" />
    </mat-form-field>
  </div>

  <div class="flex flex-col-reverse md:flex-row justify-center items-center gap-8 mt-1 mb-1">
    <button *ngIf="!!!closable" mat-raised-button (click)="onLogout()" class="ald-mat-button w-full md:w-auto">
      {{ "logout" | i18n }}
    </button>

    <button mat-raised-button (click)="onSubmit()" class="ald-mat-button primary w-full md:w-auto px-10"
      [disabled]="isInputEmpty()">
      {{ "init_client" | i18n }}
    </button>
  </div>
</div>

<ald-customer-table *ngIf="!!cSModelRetrieved" class="block w-full mt-4" [cSModelRetrieved]="cSModelRetrieved"
  (selectedCs)="selectedCs($event)" (reset)="reset()"></ald-customer-table>